import React from "react";

function ModalSubheader(props) {
  const { className, children, subheader } = props;

  return (
    <div className="row">
      <div className="col-xs-7">
        <h4 className={className}>{children}</h4>
      </div>
      <div className="col-xs-5">
        <p className="modal-p">{subheader}</p>
      </div>
    </div>
  );
}

export default ModalSubheader;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/modal/ModalSubheader.js